import React from "react";
import { ToolbarButtonProps } from "../../types/editor";

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  onClick,
  isActive = false,
  disabled = false,
  children,
  title,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    title={title}
    className={`
      btn btn-sm d-flex align-items-center justify-content-center px-2 py-2
      ${isActive ? "btn-secondary" : "btn-outline-secondary"}
      ${disabled ? "disabled" : ""}
    `}>
    {children}
  </button>
);

export default ToolbarButton;
